import subject from "../topics/Topicts";

const subjects = [
    {
      id: 1,
      subject:"physics",
      name: 'Physics',
      icon: '🪐', 
      color: '#3498db',
    },
    {
      id: 2,
      subject:"chemistry",
      name: 'Chemistry',
      icon: '⚛️', 
      color: '#2ecc71',
    },
    {
      id: 3,
      subject:"zoology",
      name: 'Zoology',
      icon: '🦁', 
      color: '#9b59b6',
    },
    {
      id: 4,
      subject:"botany",
      name: 'Botany',
      icon: '🌿', 
      color: '#2881bdff',
    }
];

export default subjects;